<div class="lm-reports-list-wrapper">
  <div id="lm-reports-search-wrapper" class="lm-reports-search-wrapper scrollable"
    [ngClass]="{'hidden': reportsArray?.length === 0}">
    @if (displaySearch) {
      <lm-reports-search
        [categoriesByModule]="categoriesByModule"
        [reportListId]="reportListId"
        [parentDataGrid]="sohoDataGridComponent"
        (displaySearchTags)="displaySearchTags($event)"
        (doKeywordSearch)="doKeywordSearch($event)"
      ></lm-reports-search>
    }

  </div> <!-- END SEARCH FORM -->

  <!-- SOHO DATAGRID -->
  <div [ngClass]="{'lm-reports-content-wrapper': true, 'show-search': displaySearch}">
    <div class="lm-reports-datagrid-wrapper scrollable-flex">
      <div class="lm-reports-toolbar-wrapper">
        <div class="lm-reports-searchtags-wrapper scrollable-flex-header">
          @if (searchTags.length > 0) {
            <lm-list-searchtags
              [automationIdPrefix]="reportListId"
              [searchTags]="searchTags"
              (searchTagRemoved)="lmReportsSearchComponent.onSearchTagRemoved($event)"
              (clearFilter)="lmReportsSearchComponent.onClearSearchTags()"
              [showRefineAndClear]="true"
              [hideRefineButton]="true"
            ></lm-list-searchtags>
          }
        </div>
        <soho-toolbar-flex
          #SohoToolbarComponent
          id="catalog-flex-menu"
          (selected)="onFlexItemSelected($event)"
          >
          <soho-toolbar-flex-more-button
            attr.id="'report-more-button'"
            [moreButtonId]="'report-more-button'"
            attr.data-automation-id="lm-report-more-button"
            >
            <ul class="popupmenu" id="report-export-menu-button_menu">
              <li id="columns-options" title="{{'ReportCatalogColumnOptions' | translate}}">
                <a  href="#"
                  id="columns-options_menu_item"
                title="{{'ReportCatalogColumnOptions' | translate}}">{{'ReportCatalogColumnOptions' | translate}}</a>
                <ul class="popupmenu" id="columns-options-menu">
                  <li id="reset-columns" title="{{'Reset' | translate}}">
                    <a  href="#"
                      id="reset-columns_menu_item"
                    title="{{'Reset' | translate}}">{{'Reset' | translate}}</a>
                  </li>
                  <li id="customize-columns" title="{{'ReportCatalogCustomizeColumns' | translate}}">
                    <a  href="#"
                      id="customize-columns_menu_item"
                    title="{{'ReportCatalogCustomizeColumns' | translate}}">{{'ReportCatalogCustomizeColumns' | translate}}</a>
                  </li>
                </ul>
              </li>
              <li id="export-catalog" title="{{'ExportTo' | translate}}">
                <a  href="#"
                  id="export-catalog_menu_item"
                title="{{'ExportTo' | translate}}">{{'ExportTo' | translate}}</a>
                <ul class="popupmenu" id="export-catalog-menu">
                  <li id="export-csv" title="{{'CSV' | translate}}">
                    <a  href="#"
                      id="export-csv_menu_item"
                    title="{{'Csv' | translate}}">{{'Csv' | translate}}</a>
                  </li>
                  <li id="export-xslx" title="{{'ReportCatalogExcel' | translate}}">
                    <a  href="#"
                      id="export-xslx_menu_item"
                    title="{{'ReportCatalogExcel' | translate}}">{{'ReportCatalogExcel' | translate}}</a>
                  </li>
                </ul>
              </li>
            </ul>
          </soho-toolbar-flex-more-button>
        </soho-toolbar-flex>
      </div>

      @if (reportsArray) {
        <div class="scrollable-flex-content" style="margin-top: 5px;"
          attr.data-automation-id="lm-reports-list-{{reportListId}}-datagrid"
          soho-datagrid  #columnDataGridComponent
          [attr.id]="columnDataGridComponent"
          [gridOptions]="columnGridOptions"
          (rowClicked)="onRowClicked($event)"
          (keydown)="onDatagridKeydown($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (contextMenu)="onContextMenu($event)"
          (sorted)="onColumnSort($event)"
          >
          <!--        [toolbar]="toolbarOptions"-->
        </div>
      }
    </div>
  </div>
</div>

@if (displayContextMenu) {
  <div class="popupmenu-wrapper" role="application">
    <ul soho-popupmenu
      id="{{reportListId}}_context-menu"
      menu="{{reportListId}}_context-menu"
      attr.data-automation-id="{{reportListId}}_context-menu"
      [ngClass]="'is-context-menu'"
      trigger='immediate'
      [attachToBody]="true"
      [removeOnDestroy]="true"
      [eventObj]="contextMenuEvent"
      (selected)="onContextMenuItemSelected($event)"
      (close)="onCloseContextMenu($event)"
      [beforeOpen]="onBeforeContextMenuOpen"
      >
    </ul>
  </div>
}

<div #reportFormDialog>
  <!-- dialog placeholder used to display action form from menu -->
</div>